/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarToNutshell from './icon-calendar-to-nutshell.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <CalendarToNutshell {...validProps} />;
}
SvgComponent.iconName = 'calendarToNutshell';

export const CalendarToNutshellIcon = svgIconWrapper(SvgComponent);
